import { ProductStatus, ProductStatusFN } from "../../constants/enum";

function BadgeProductStatus({ status = "", textSize = "text-base" }) {
  let st = status;
  let className = "";
  switch (st) {
    case ProductStatus.NPD:
      className = "badge-product-status-npd";
      st = ProductStatusFN.NPD;
      break;
    case ProductStatus.Launch:
      className = "badge-product-status-launch";
      st = ProductStatusFN.Launch;
      break;
    case ProductStatus.Promotion:
      className = "badge-product-status-promotion";
      st = ProductStatusFN.Promotion;
      break;
    case ProductStatus.Normal:
      className = "badge-product-status-normal";
      st = ProductStatusFN.Normal;
      break;
    case ProductStatus.TobeDiscontinued:
      className = "badge-product-status-tobediscontinued";
      st = ProductStatusFN.TobeDiscontinued;
      break;
    case ProductStatus.Obsolete:
      className = "badge-product-status-obsolete";
      st = ProductStatusFN.Obsolete;
      break;
    // case ProductStatus.Relaunch:
    //   className = 'badge-product-status-relaunch';
    //   st = ProductStatusFN.Relaunch
    //   break;
    default:
      className = "badge-product-status-obsolete";
      break;
  }
  return <button className={`${className} ${textSize}`}>{st}</button>;
}
export default BadgeProductStatus;
